/* eslint-disable no-unused-vars */
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Popover,
  Paper,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  IconButton,
  CircularProgress,
  Grid,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { KeysCreate, KeysUpdate, KeysDelete } from '../sections/@dashboard/admin';
// api
import API from '../api';

// ----------------------------------------------------------------------

export default function AdminPage() {
  const [open, setOpen] = useState(null);

  const [loading, setLoading] = useState(false);

  const [selectedFeedback, setSelectedFeedback] = useState({});

  const [feedbacks, setFeedbacks] = useState([]);

  const fetchFeedbacks = async () => {
    const response = await API.get('/auth/user');
    const {
      data: { data },
    } = response;
    // todo: remove console log, and set pagination
    // console.log(data)
    setFeedbacks(data);
  };

  const [divs, setDivs] = useState([]);

  const fetchDivs = async ({ paramPage = 1, paramLimit = 100 }) => {
    const response = await API.get(`/division?page=${paramPage}&limit=${paramLimit}`);
    const {
      data: { data, success },
    } = response;
    if (success === 1) {
      setDivs(data);
    }
  };

  useEffect(() => {
    try {
      setLoading(true);
      fetchFeedbacks();
      fetchDivs({});
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleOpenMenu = (event, data) => {
    setSelectedFeedback(data);
    setOpen(event.currentTarget);
  };

  const resetPage = () => {
    setOpen(null);
    setSelectedFeedback({});
    fetchFeedbacks();
    fetchDivs({});
  };

  return (
    <>
      <Helmet>
        <title>Хэрэглэгч</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Хэрэглэгч
          </Typography>
          <KeysCreate resetPage={resetPage} divisions={divs} />
        </Stack>

        <Scrollbar>
          <Card>
            <Grid container>
              <Grid item xs={6} />
              <Grid item xs={6}>
                {loading && <CircularProgress />}
              </Grid>
            </Grid>
            <TableContainer sx={{ minWidth: 400 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>№</TableCell>
                    <TableCell sx={{ maxWidth: '75px' }}>Username</TableCell>
                    <TableCell>Төрөл</TableCell>
                    <TableCell>Харьяа хэлтэс</TableCell>
                    <TableCell>Дэлгэрэнгүй</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {feedbacks?.length > 0 ? (
                    feedbacks.map((rowData, index) => {
                      const {
                        key_id,
                        a_username,
                        role,
                        d_name,
                        l_name,
                        f_name,
                        mail,
                        phone,
                        phone1,
                        gender,
                        register,
                        story,
                        birth,
                      } = rowData;
                      return (
                        <TableRow key={key_id} hover>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap px={2}>
                                {index + 1}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none" sx={{ maxWidth: '75px' }}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap px={2}>
                                {a_username}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none" sx={{ maxWidth: '75px' }}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap px={2}>
                                {role === 1 ? 'Super Admin' : 'Admin'}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none" sx={{ maxWidth: '100px' }}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle" noWrap px={2}>
                                {d_name}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none" sx={{ maxWidth: '300px' }}>
                            <Stack direction="column" alignItems="left" spacing={2}>
                              <Typography variant="subtitle" p={2}>
                                <ul>
                                  {l_name && <li>{l_name}</li>}
                                  {f_name && <li>{f_name}</li>}
                                  {mail && <li>{mail}</li>}
                                  {phone && <li>{phone}</li>}
                                  {phone1 && <li>{phone1}</li>}
                                  {gender && <li>{gender}</li>}
                                  {register && <li>{register}</li>}
                                  {story && <li>{story}</li>}
                                  {birth && <li>{birth}</li>}
                                </ul>
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="right">
                            <IconButton
                              size="large"
                              color="inherit"
                              onClick={(event) => handleOpenMenu(event, rowData)}
                            >
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Өгөгдөл олдсонгүй
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Scrollbar>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <KeysUpdate selectedFeedback={selectedFeedback} resetPage={resetPage} />
        </MenuItem>

        <MenuItem>
          <KeysDelete selectedAdmin={selectedFeedback} resetPage={resetPage} divisions={divs} />
        </MenuItem>
      </Popover>
    </>
  );
}
